"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m16.351 9.856-5.336 5.27-2.825-2.234a.5.5 0 0 1 .62-.784l2.131 1.685 4.708-4.649a.5.5 0 1 1 .702.712"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0"
  })]
}), 'CheckCircle');
//# sourceMappingURL=index.js.map